import type { ReactNode } from "react";
import React, { cloneElement, isValidElement } from "react";
import type { IButtonSize } from "./types";

type Props = {
  icon: ReactNode;
  size?: IButtonSize;
};

type IconProps = {
  size?: number | string;
  width?: number | string;
  height?: number | string;
};

export const ButtonIcon = ({ icon, size = "sm" }: Props) => {
  const iconSizeMap: Record<IButtonSize, string> = {
    xs: "0.875rem",
    sm: "1.125rem",
    md: "1.25rem",
    lg: "1.25rem",
  };

  if (icon === null || icon === undefined || icon === false) return null;

  if (!isValidElement<IconProps>(icon)) return <>{icon}</>;

  if (icon.type === React.Fragment) return icon;

  const { size: ownSize, width, height } = icon.props ?? {};
  if (ownSize != null || width != null || height != null) return icon;

  const target = iconSizeMap[size];

  if (typeof icon.type === "string" && icon.type === "svg") {
    return cloneElement(icon, { width: target, height: target });
  }

  return cloneElement(icon, { size: target });
};
